export default class IMPSBaseModel {
    impsId: number = 0;
}
